import {ClockIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu} from '@primer/react'

import {useActivityAnalytics} from '../hooks/use-activity-analytics'
import type {ActivityTimePeriod} from '../types/activity-types'

const orderedPeriods: ActivityTimePeriod[] = ['day', 'week', 'month', 'quarter', 'year', 'all']

const activityTimePeriods: Record<ActivityTimePeriod, string> = {
  day: 'Last 24 hours',
  week: 'Last week',
  month: 'Last month',
  quarter: 'Last quarter',
  year: 'Last year',
  all: 'All time',
}

export function ActivityTimeFilter({
  currentActivityTimePeriod,
  onSelect,
}: {
  currentActivityTimePeriod: ActivityTimePeriod
  onSelect: (activityTimePeriod: ActivityTimePeriod) => void
}) {
  const {sendActivityClickEvent} = useActivityAnalytics()
  return (
    <ActionMenu onOpenChange={open => open && sendActivityClickEvent('TIME_FILTER')}>
      <ActionMenu.Button
        aria-label={`Filter by time: ${activityTimePeriods[currentActivityTimePeriod]}`}
        leadingVisual={ClockIcon}
        size="medium"
      >
        {activityTimePeriods[currentActivityTimePeriod]}
      </ActionMenu.Button>
      <ActionMenu.Overlay width="medium">
        <ActionList selectionVariant="single">
          {orderedPeriods.map(timePeriod => (
            <ActionList.Item
              key={timePeriod}
              selected={timePeriod === currentActivityTimePeriod}
              onSelect={() => {
                sendActivityClickEvent('TIME_FILTER.VALUE', {['selected_time_period']: timePeriod})
                onSelect(timePeriod)
              }}
            >
              {activityTimePeriods[timePeriod]}
            </ActionList.Item>
          ))}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
